// All help copy of the AI Providers & Models screen. Each entry feeds a HelpPopover. Generic examples only.

export const HELP = {
  lucyModel: {
    label: 'Lucy model',
    what: 'The model the in-app assistant runs on. Only enabled models with a context window of at least 32k tokens that passed their Test are offered.',
    watchOut: 'Lucy switches on the next message after Save.',
  },
  key: {
    label: 'Key',
    what: 'The id chat bots store for this provider. It cannot change after the provider is created.',
    examples: [
      { label: 'ml-models', value: 'ml-models' },
      { label: 'deepseek', value: 'deepseek' },
    ],
  },
  baseUrl: {
    label: 'Base URL',
    what: "Where the host listens. Blank uses the vendor's own API. OpenAI style includes /v1; Anthropic style is the root only.",
    examples: [
      { label: 'http://ml-models.internal:8000/v1', value: 'http://ml-models.internal:8000/v1' },
      { label: 'http://ml-models.internal:8000', value: 'http://ml-models.internal:8000' },
      { label: 'https://api.deepseek.com/v1', value: 'https://api.deepseek.com/v1' },
    ],
    watchOut:
      'localhost is the API pod itself; use a name or IP the cluster can reach. Changing it needs the API key again.',
  },
  apiKey: {
    label: 'API key',
    what: 'Stored encrypted and never shown again. Blank means the host takes no key.',
    watchOut: 'Seeded providers use the Releva token from the environment, or the merchant token on a chat bot.',
  },
  apiStyle: {
    openai: {
      label: 'API style: OpenAI',
      what: 'The host speaks the OpenAI Chat Completions protocol. A self-hosted server must do all of this to pass the Test:',
      examples: [
        { label: 'POST /v1/chat/completions with SSE streaming' },
        { label: 'tool_calls deltas carry index and id' },
        { label: "finish_reason 'tool_calls' when it calls a tool" },
        { label: "accepts max_tokens, stream_options.include_usage and role:'tool' messages" },
        { label: 'accepts any API key, or none' },
        { label: 'context length set explicitly on the server' },
        { label: 'reachable by cluster DNS name or IP' },
      ],
    },
    anthropic: {
      label: 'API style: Anthropic',
      what: 'The host speaks the Anthropic Messages protocol. A self-hosted server must do all of this to pass the Test:',
      examples: [
        { label: 'POST /v1/messages with SSE streaming' },
        { label: 'message_start with usage' },
        { label: 'content_block_start / delta / stop with dense indexes' },
        { label: 'message_delta with stop_reason and usage.output_tokens, then message_stop' },
        { label: "stop_reason 'tool_use' when it calls a tool" },
        { label: 'accepts tool_result blocks and a plain-string system' },
        { label: 'accepts any API key, or none' },
        { label: 'context length set explicitly on the server' },
        { label: 'reachable by cluster DNS name or IP' },
      ],
    },
  },
  modelId: {
    label: 'Model id',
    what: 'The exact id the host expects in the request.',
    examples: [
      { label: 'deepseek-chat', value: 'deepseek-chat' },
      { label: 'qwen3-32b', value: 'qwen3-32b' },
    ],
  },
  contextWindow: {
    label: 'Context window',
    what: 'The most tokens the host accepts in one request, prompt and reply together.',
    examples: [
      { label: '32768', value: 32768 },
      { label: '131072', value: 131072 },
    ],
  },
  maxOutputTokens: {
    label: 'Max output tokens',
    what: "The budget for one reply, reasoning included. It is not the model's maximum.",
    examples: [
      { label: '4000', value: 4000 },
      { label: '8000', value: 8000 },
    ],
    watchOut: 'The prompt plus this must fit in the context window.',
  },
  echoReasoning: {
    label: 'Send reasoning back on tool turns',
    what: "Sends the model's reasoning back to the host with each tool result.",
    watchOut: 'Turn it on only when the Test shows reasoning_required.',
  },
};

export const applyExample = (setValue, previous) => (value) => {
  setValue(value);
  return () => setValue(previous);
};
